// import React, { useEffect, useState } from "react";
// import { Table, Button, Form, InputGroup, Pagination, Badge, Spinner } from "react-bootstrap";
// import api from "../../api";
// import Can from "../../components/Can";
// import TaskApprovalPolicyEditor from "../../components/tasks/TaskApprovalPolicyEditor";
// import TaskApprovalPolicyPreview from "../../components/tasks/TaskApprovalPolicyPreview";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import ConfirmModal from "../../components/common/ConfirmModal";
// import EmptyState from "../../components/common/EmptyState";
// import { FaShieldAlt } from "react-icons/fa";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
// import "./TaskApprovalPolicyManagementPage.css";

// // Phase 4B, §17/§26. Approval policies are OPT-IN configuration — this page
// // never seeds or implies a mandatory/global policy; an empty list is the
// // normal, healthy default state for a fresh install.
// export default function TaskApprovalPolicyManagementPage() {
//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);

//   const [search, setSearch] = useState("");
//   const [taskTypeId, setTaskTypeId] = useState("");
//   const [departmentId, setDepartmentId] = useState("");
//   const [projectId, setProjectId] = useState("");
//   const [triggerType, setTriggerType] = useState("");
//   const [isActive, setIsActive] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const pageSize = 20;

//   const [taskTypes, setTaskTypes] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [projectModules, setProjectModules] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [taskStatuses, setTaskStatuses] = useState([]);

//   const [showEditor, setShowEditor] = useState(false);
//   const [editingPolicy, setEditingPolicy] = useState(null);
//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [deleting, setDeleting] = useState(false);

//   const fetchRows = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/task-approval-policies", {
//         params: {
//           search: search || undefined, task_type_id: taskTypeId || undefined, department_id: departmentId || undefined,
//           project_id: projectId || undefined, trigger_type: triggerType || undefined, is_active: isActive !== "" ? isActive : undefined,
//           page: currentPage, pageSize,
//         },
//       });
//       setRows(Array.isArray(res.data?.data) ? res.data.data : []);
//       setTotal(res.data?.meta?.total || 0);
//     } catch (err) {
//       console.error("Fetch approval policies error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch approval policies");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchRows();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search, taskTypeId, departmentId, projectId, triggerType, isActive, currentPage]);

//   useEffect(() => {
//     Promise.all([
//       api.get("/task-types", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
//       api.get("/departments", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
//       api.get("/projects", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
//       api.get("/users").catch(() => null),
//       api.get("/roles").catch(() => null),
//       api.get("/task-statuses", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
//     ]).then(([ttRes, deptRes, pRes, uRes, rRes, stRes]) => {
//       setTaskTypes(Array.isArray(ttRes?.data?.data) ? ttRes.data.data : []);
//       setDepartments(Array.isArray(deptRes?.data?.data) ? deptRes.data.data : []);
//       setProjects(Array.isArray(pRes?.data?.data) ? pRes.data.data : []);
//       setUsers(Array.isArray(uRes?.data) ? uRes.data : []);
//       setRoles(Array.isArray(rRes?.data) ? rRes.data : []);
//       setTaskStatuses(Array.isArray(stRes?.data?.data) ? stRes.data.data : []);
//     });
//   }, []);

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const openCreate = () => { setEditingPolicy(null); setShowEditor(true); };
//   const openEdit = async (row) => {
//     try {
//       const res = await api.get(`/task-approval-policies/${row.id}`);
//       setEditingPolicy(res.data?.data);
//       setShowEditor(true);
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to load policy detail");
//     }
//   };

//   const toggleStatus = async (row) => {
//     try {
//       await api.patch(`/task-approval-policies/${row.id}/status`, { is_active: !row.is_active });
//       toast.success(row.is_active ? "Policy deactivated" : "Policy activated");
//       fetchRows();
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to update policy status");
//     }
//   };

//   const confirmDelete = async () => {
//     if (!deleteTarget) return;
//     setDeleting(true);
//     try {
//       await api.delete(`/task-approval-policies/${deleteTarget.id}`);
//       toast.success("Policy deleted");
//       setDeleteTarget(null);
//       fetchRows();
//     } catch (err) {
//       const data = err.response?.data;
//       if (data?.code === "TASK_APPROVAL_POLICY_IN_USE") toast.error("This policy has been used by approval requests — deactivate it instead.");
//       else toast.error(data?.message || "Failed to delete policy");
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const hasActiveFilters = !!(search || taskTypeId || departmentId || projectId || triggerType || isActive !== "");
//   const clearFilters = () => {
//     setCurrentPage(1);
//     setSearch(""); setTaskTypeId(""); setDepartmentId(""); setProjectId(""); setTriggerType(""); setIsActive("");
//   };

//   return (
//     <div className="unit-page approvalpolicy-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Tasks</div>
//           <h2>Task Approval Policies</h2>
//           <p>Optional configuration — a task only requires approval when an active policy's context and trigger both match. Nothing here is mandatory.</p>
//         </div>
//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchRows}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>
//           <Can moduleKey="task_approval_policies" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openCreate}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               New Policy
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <TaskApprovalPolicyPreview taskTypes={taskTypes} projects={projects} projectModules={projectModules} onProjectChange={async (pid) => {
//         if (!pid) { setProjectModules([]); return; }
//         const res = await api.get(`/projects/${pid}/modules`, { params: { is_active: 1, pageSize: 200 } }).catch(() => null);
//         setProjectModules(Array.isArray(res?.data?.data) ? res.data.data : []);
//       }} />

//       <div className="unit-card">
//         <div className="unit-toolbar" style={{ flexWrap: "wrap", gap: 8 }}>
//           <div>
//             <h5>
//               <i className="fa-solid fa-shield-halved policy-list-icon" aria-hidden="true"></i>
//               Approval Policy List
//             </h5>
//             <p>Search, filter, and manage task approval policies.</p>
//           </div>
//           <div className="unit-toolbar-actions" style={{ flexWrap: "wrap", gap: 8 }}>
//             <InputGroup className="unit-search" style={{ maxWidth: 200 }}>
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control placeholder="Search..." aria-label="Search approval policies" value={search} onChange={(e) => { setCurrentPage(1); setSearch(e.target.value); }} />
//             </InputGroup>
//             <Form.Select style={{ maxWidth: 170 }} value={taskTypeId} onChange={(e) => { setCurrentPage(1); setTaskTypeId(e.target.value); }}>
//               <option value="">All Task Types</option>
//               {taskTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
//             </Form.Select>
//             <Form.Select style={{ maxWidth: 170 }} value={departmentId} onChange={(e) => { setCurrentPage(1); setDepartmentId(e.target.value); }}>
//               <option value="">All Departments</option>
//               {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
//             </Form.Select>
//             <Form.Select style={{ maxWidth: 170 }} value={projectId} onChange={(e) => { setCurrentPage(1); setProjectId(e.target.value); }}>
//               <option value="">All Projects</option>
//               {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
//             </Form.Select>
//             <Form.Select style={{ maxWidth: 170 }} value={triggerType} onChange={(e) => { setCurrentPage(1); setTriggerType(e.target.value); }}>
//               <option value="">All Triggers</option>
//               <option value="MANUAL_SUBMISSION">Manual Submission</option>
//               <option value="BEFORE_TRANSITION">Before Transition</option>
//               <option value="ON_STATUS_ENTRY">On Status Entry</option>
//             </Form.Select>
//             <Form.Select style={{ maxWidth: 140 }} value={isActive} onChange={(e) => { setCurrentPage(1); setIsActive(e.target.value); }}>
//               <option value="">All Statuses</option>
//               <option value="1">Active</option>
//               <option value="0">Inactive</option>
//             </Form.Select>
//             {hasActiveFilters && <Button className="unit-clear-filters-btn" onClick={clearFilters}>Clear Filters</Button>}
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader"><Spinner animation="border" /><p>Loading approval policies...</p></div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th>Code</th><th>Name</th><th>Scope</th><th>Trigger</th><th>Stages</th><th>Status</th><th className="text-end">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.length > 0 ? rows.map((row) => (
//                   <tr key={row.id}>
//                     <td className="small">{row.code}</td>
//                     <td>{row.name}</td>
//                     <td className="small text-muted">
//                       {row.task_type_name || row.department_name || row.project_name || row.project_module_name
//                         ? [row.task_type_name, row.department_name, row.project_name, row.project_module_name].filter(Boolean).join(" / ")
//                         : "Global"}
//                     </td>
//                     <td><Badge bg="light" text="dark">{row.trigger_type?.replace(/_/g, " ")}</Badge></td>
//                     <td>{row.active_stage_count}</td>
//                     <td><Badge className={`unit-status${row.is_active ? "" : " unit-status-inactive"}`}>{row.is_active ? "Active" : "Inactive"}</Badge></td>
//                     <td className="text-end">
//                       <div className="unit-actions" style={{ justifyContent: "flex-end", flexWrap: "wrap" }}>
//                         <Can moduleKey="task_approval_policies" actionKey="edit">
//                           <Button className="unit-icon-btn unit-edit" title="Edit" aria-label={`Edit ${row.name || "policy"}`} onClick={() => openEdit(row)}>
//                             <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                           </Button>
//                         </Can>
//                         <Can moduleKey="task_approval_policies" actionKey={row.is_active ? "deactivate" : "activate"}>
//                           <Button className="unit-icon-btn policy-toggle" title={row.is_active ? "Deactivate" : "Activate"} aria-label={row.is_active ? "Deactivate" : "Activate"} onClick={() => toggleStatus(row)}>
//                             <i className={`fa-solid ${row.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
//                           </Button>
//                         </Can>
//                         <Can moduleKey="task_approval_policies" actionKey="delete">
//                           <Button className="unit-icon-btn unit-delete" title="Delete" aria-label={`Delete ${row.name || "policy"}`} onClick={() => setDeleteTarget(row)}>
//                             <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                           </Button>
//                         </Can>
//                       </div>
//                     </td>
//                   </tr>
//                 )) : (
//                   <tr>
//                     <td colSpan="7">
//                       <EmptyState
//                         icon={FaShieldAlt}
//                         title="No approval policies configured"
//                         message={hasActiveFilters ? "Try another search or clear filters." : "This is normal — tasks require approval only once a policy is deliberately created and activated."}
//                         action={hasActiveFilters ? (
//                           <Button className="unit-btn unit-btn-light" onClick={clearFilters}>Clear Filters</Button>
//                         ) : (
//                           <Can moduleKey="task_approval_policies" actionKey="create">
//                             <Button className="unit-btn unit-btn-primary" onClick={openCreate}>+ New Policy</Button>
//                           </Can>
//                         )}
//                       />
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">Showing <strong>{rows.length}</strong> of <strong>{total}</strong> item(s)</div>
//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>
//               ))}
//               <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <TaskApprovalPolicyEditor
//         show={showEditor}
//         onHide={() => setShowEditor(false)}
//         policy={editingPolicy}
//         taskTypes={taskTypes}
//         departments={departments}
//         projects={projects}
//         users={users}
//         roles={roles}
//         taskStatuses={taskStatuses}
//         onSaved={fetchRows}
//       />

//       <ConfirmModal
//         show={!!deleteTarget}
//         onHide={() => setDeleteTarget(null)}
//         onConfirm={confirmDelete}
//         busy={deleting}
//         title="Delete Policy"
//         message={`Are you sure you want to delete "${deleteTarget?.name}"? This action cannot be undone. If this policy has ever been used by an approval request, deletion will be blocked — deactivate it instead.`}
//         confirmLabel="Delete"
//         dialogClassName="admin-teal-modal admin-teal-modal-sm admin-teal-modal-danger"
//         icon={<DeleteOutlineIcon fontSize="inherit" />}
//         iconClassName="admin-modal-danger-icon"
//       />
//     </div>
//   );
// }



import React, { useEffect, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import { Table, Button, Form, InputGroup, Pagination, Badge, Spinner } from "react-bootstrap";
import api from "../../api";
import Can from "../../components/Can";
import TaskApprovalPolicyEditor from "../../components/tasks/TaskApprovalPolicyEditor";
import TaskApprovalPolicyPreview from "../../components/tasks/TaskApprovalPolicyPreview";
import { toast } from "react-toastify";
import ConfirmModal from "../../components/common/ConfirmModal";
import EmptyState from "../../components/common/EmptyState";
import { FaShieldAlt } from "react-icons/fa";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import "./TaskApprovalPolicyManagementPage.css";

// Phase 4B, §17/§26. Approval policies are OPT-IN configuration — this page
// never seeds or implies a mandatory/global policy; an empty list is the
// normal, healthy default state for a fresh install.
export default function TaskApprovalPolicyManagementPage() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");
  const [taskTypeId, setTaskTypeId] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [projectId, setProjectId] = useState("");
  const [triggerType, setTriggerType] = useState("");
  const [isActive, setIsActive] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const [taskTypes, setTaskTypes] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [projects, setProjects] = useState([]);
  const [projectModules, setProjectModules] = useState([]);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [taskStatuses, setTaskStatuses] = useState([]);

  const [showEditor, setShowEditor] = useState(false);
  const [editingPolicy, setEditingPolicy] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const fetchRows = async () => {
    try {
      setLoading(true);
      const res = await api.get("/task-approval-policies", {
        params: {
          search: search || undefined, task_type_id: taskTypeId || undefined, department_id: departmentId || undefined,
          project_id: projectId || undefined, trigger_type: triggerType || undefined, is_active: isActive !== "" ? isActive : undefined,
          page: currentPage, pageSize,
        },
      });
      setRows(Array.isArray(res.data?.data) ? res.data.data : []);
      setTotal(res.data?.meta?.total || 0);
    } catch (err) {
      console.error("Fetch approval policies error:", err);
      toast.error(err.response?.data?.message || "Failed to fetch approval policies");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, taskTypeId, departmentId, projectId, triggerType, isActive, currentPage]);

  useEffect(() => {
    Promise.all([
      api.get("/task-types", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
      api.get("/departments", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
      api.get("/projects", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
      api.get("/users").catch(() => null),
      api.get("/roles").catch(() => null),
      api.get("/task-statuses", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
    ]).then(([ttRes, deptRes, pRes, uRes, rRes, stRes]) => {
      setTaskTypes(Array.isArray(ttRes?.data?.data) ? ttRes.data.data : []);
      setDepartments(Array.isArray(deptRes?.data?.data) ? deptRes.data.data : []);
      setProjects(Array.isArray(pRes?.data?.data) ? pRes.data.data : []);
      setUsers(Array.isArray(uRes?.data) ? uRes.data : []);
      setRoles(Array.isArray(rRes?.data) ? rRes.data : []);
      setTaskStatuses(Array.isArray(stRes?.data?.data) ? stRes.data.data : []);
    });
  }, []);

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const openCreate = () => { setEditingPolicy(null); setShowEditor(true); };
  const openEdit = async (row) => {
    try {
      const res = await api.get(`/task-approval-policies/${row.id}`);
      setEditingPolicy(res.data?.data);
      setShowEditor(true);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load policy detail");
    }
  };

  const toggleStatus = async (row) => {
    try {
      await api.patch(`/task-approval-policies/${row.id}/status`, { is_active: !row.is_active });
      toast.success(row.is_active ? "Policy deactivated" : "Policy activated");
      fetchRows();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update policy status");
    }
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      await api.delete(`/task-approval-policies/${deleteTarget.id}`);
      toast.success("Policy deleted");
      setDeleteTarget(null);
      fetchRows();
    } catch (err) {
      const data = err.response?.data;
      if (data?.code === "TASK_APPROVAL_POLICY_IN_USE") toast.error("This policy has been used by approval requests — deactivate it instead.");
      else toast.error(data?.message || "Failed to delete policy");
    } finally {
      setDeleting(false);
    }
  };

  const hasActiveFilters = !!(search || taskTypeId || departmentId || projectId || triggerType || isActive !== "");
  const clearFilters = () => {
    setCurrentPage(1);
    setSearch(""); setTaskTypeId(""); setDepartmentId(""); setProjectId(""); setTriggerType(""); setIsActive("");
  };

  return (
    <div className="unit-page approvalpolicy-theme">

      <div className="unit-header tap-heading-box">
        <div className="tap-heading-content">
          <div className="tap-heading-icon">
            <FaShieldAlt aria-hidden="true" />
          </div>
          <div>
            <div className="unit-page-label">Tasks</div>
            <h2>Task Approval Policies</h2>
            <p>Optional configuration — a task only requires approval when an active policy's context and trigger both match. Nothing here is mandatory.</p>
          </div>
        </div>
        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchRows}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>
          <Can moduleKey="task_approval_policies" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={openCreate}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              New Policy
            </Button>
          </Can>
        </div>
      </div>

      <TaskApprovalPolicyPreview taskTypes={taskTypes} projects={projects} projectModules={projectModules} onProjectChange={async (pid) => {
        if (!pid) { setProjectModules([]); return; }
        const res = await api.get(`/projects/${pid}/modules`, { params: { is_active: 1, pageSize: 200 } }).catch(() => null);
        setProjectModules(Array.isArray(res?.data?.data) ? res.data.data : []);
      }} />

      <div className="unit-card">
        <div className="unit-toolbar" style={{ flexWrap: "wrap", gap: 8 }}>
          <div>
            <h5>
              <i className="fa-solid fa-shield-halved policy-list-icon" aria-hidden="true"></i>
              Approval Policy List
            </h5>
            <p>Search, filter, and manage task approval policies.</p>
          </div>
          <div className="unit-toolbar-actions tap-toolbar-actions">
            <InputGroup className="unit-search tap-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control placeholder="Search..." aria-label="Search approval policies" value={search} onChange={(e) => { setCurrentPage(1); setSearch(e.target.value); }} />
            </InputGroup>
            <Form.Select className="tap-filter tap-filter-tasktype" value={taskTypeId} onChange={(e) => { setCurrentPage(1); setTaskTypeId(e.target.value); }}>
              <option value="">All Task Types</option>
              {taskTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </Form.Select>
            <Form.Select className="tap-filter tap-filter-dept" value={departmentId} onChange={(e) => { setCurrentPage(1); setDepartmentId(e.target.value); }}>
              <option value="">All Departments</option>
              {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
            </Form.Select>
            <Form.Select className="tap-filter tap-filter-project" value={projectId} onChange={(e) => { setCurrentPage(1); setProjectId(e.target.value); }}>
              <option value="">All Projects</option>
              {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
            </Form.Select>
            <Form.Select className="tap-filter tap-filter-trigger" value={triggerType} onChange={(e) => { setCurrentPage(1); setTriggerType(e.target.value); }}>
              <option value="">All Triggers</option>
              <option value="MANUAL_SUBMISSION">Manual Submission</option>
              <option value="BEFORE_TRANSITION">Before Transition</option>
              <option value="ON_STATUS_ENTRY">On Status Entry</option>
            </Form.Select>
            <Form.Select className="tap-filter tap-filter-status" value={isActive} onChange={(e) => { setCurrentPage(1); setIsActive(e.target.value); }}>
              <option value="">All Statuses</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </Form.Select>
            {hasActiveFilters && <Button className="unit-clear-filters-btn" onClick={clearFilters}>Clear Filters</Button>}
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader"><Spinner animation="border" /><p>Loading approval policies...</p></div>
          ) : (
            <Table responsive className="unit-table">
              <thead>
                <tr>
                  <th>Code</th><th>Name</th><th>Scope</th><th>Trigger</th><th>Stages</th><th>Status</th><th className="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? rows.map((row) => (
                  <tr key={row.id}>
                    <td className="small">{row.code}</td>
                    <td>{row.name}</td>
                    <td className="small text-muted">
                      {row.task_type_name || row.department_name || row.project_name || row.project_module_name
                        ? [row.task_type_name, row.department_name, row.project_name, row.project_module_name].filter(Boolean).join(" / ")
                        : "Global"}
                    </td>
                    <td><Badge bg="light" text="dark">{row.trigger_type?.replace(/_/g, " ")}</Badge></td>
                    <td>{row.active_stage_count}</td>
                    <td><Badge className={`unit-status${row.is_active ? "" : " unit-status-inactive"}`}>{row.is_active ? "Active" : "Inactive"}</Badge></td>
                    <td className="text-end">
                      <div className="unit-actions">
                        <Can moduleKey="task_approval_policies" actionKey="edit">
                          <Button className="unit-icon-btn unit-edit" title="Edit Policy" aria-label={`Edit ${row.name || "policy"}`} onClick={() => openEdit(row)}>
                            <i className="fa-solid fa-pen" aria-hidden="true"></i>
                          </Button>
                        </Can>
                        <Can moduleKey="task_approval_policies" actionKey={row.is_active ? "deactivate" : "activate"}>
                          <Button
                            className={`unit-icon-btn policy-toggle${row.is_active ? " policy-toggle--deactivate" : " policy-toggle--activate"}`}
                            title={row.is_active ? "Deactivate Policy" : "Activate Policy"}
                            aria-label={`${row.is_active ? "Deactivate" : "Activate"} ${row.name || "policy"}`}
                            onClick={() => toggleStatus(row)}
                          >
                            <i className={`fa-solid ${row.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
                          </Button>
                        </Can>
                        <Can moduleKey="task_approval_policies" actionKey="delete">
                          <Button className="unit-icon-btn unit-delete" title="Delete Policy" aria-label={`Delete ${row.name || "policy"}`} onClick={() => setDeleteTarget(row)}>
                            <i className="fa-solid fa-trash" aria-hidden="true"></i>
                          </Button>
                        </Can>
                      </div>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="7">
                      <EmptyState
                        icon={FaShieldAlt}
                        title="No approval policies configured"
                        message={hasActiveFilters ? "Try another search or clear filters." : "This is normal — tasks require approval only once a policy is deliberately created and activated."}
                        action={hasActiveFilters ? (
                          <Button className="unit-btn unit-btn-light" onClick={clearFilters}>Clear Filters</Button>
                        ) : (
                          <Can moduleKey="task_approval_policies" actionKey="create">
                            <Button className="unit-btn unit-btn-primary" onClick={openCreate}>+ New Policy</Button>
                          </Can>
                        )}
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">Showing <strong>{rows.length}</strong> of <strong>{total}</strong> item(s)</div>
          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>
              )), currentPage)}
              <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
            </Pagination>
          )}
        </div>
      </div>

      <TaskApprovalPolicyEditor
        show={showEditor}
        onHide={() => setShowEditor(false)}
        policy={editingPolicy}
        taskTypes={taskTypes}
        departments={departments}
        projects={projects}
        users={users}
        roles={roles}
        taskStatuses={taskStatuses}
        onSaved={fetchRows}
      />

      <ConfirmModal
        show={!!deleteTarget}
        onHide={() => setDeleteTarget(null)}
        onConfirm={confirmDelete}
        busy={deleting}
        title="Delete Policy"
        message={`Are you sure you want to delete "${deleteTarget?.name}"? This action cannot be undone. If this policy has ever been used by an approval request, deletion will be blocked — deactivate it instead.`}
        confirmLabel="Delete"
        dialogClassName="admin-teal-modal admin-teal-modal-sm admin-teal-modal-danger"
        icon={<DeleteOutlineIcon fontSize="inherit" />}
        iconClassName="admin-modal-danger-icon"
      />
    </div>
  );
}
